var _circle, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssignment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.0002,
    cy: 20.0002,
    r: 16.6667,
    fill: "#1A73E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1958 10.7144C13.4487 10.7144 12.8579 11.3225 12.8579 12.0523V27.8121C12.8579 28.5593 13.4661 29.1501 14.1958 29.1501H26.4979C27.2451 29.1501 27.8358 28.5419 27.8358 27.8121V15.6491L22.9011 10.7144H14.1958ZM26.689 27.8295C26.689 27.9338 26.6022 28.0206 26.4979 28.0206H14.1958C14.0916 28.0206 14.0047 27.9338 14.0047 27.8295V12.0523C14.0047 11.948 14.0916 11.8612 14.1958 11.8612H21.9281V15.2668C21.9281 16.014 22.5362 16.6047 23.266 16.6047H26.689V27.8295ZM23.0749 12.5388L26.0114 15.4753H23.266C23.1618 15.4753 23.0749 15.3884 23.0749 15.2842V12.5388Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7388 18.186H23.6891",
    stroke: "white",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7388 21.6616H23.6891",
    stroke: "white",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7388 25.1362H23.6891",
    stroke: "white",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignment);
export default __webpack_public_path__ + "static/media/Assignment.92769fe5.svg";
export { ForwardRef as ReactComponent };